import { Eczane } from './../_models/eczane';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class EczaneService {
    baseUrl: String = environment.apiUrl + "nobetcieczaneler";

    constructor(private http: HttpClient) { }

    getPlaylists(): Observable<Eczane[]> {

        return this.http.get<any[]>(this.baseUrl + '?tarih=' + this.getDate());

    }

    private getDate() {
      var d = new Date(),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2)
          month = '0' + month;
      if (day.length < 2)
          day = '0' + day;

      return [day, month, year].join('.');
  }

}



// WEBPACK FOOTER //
// ./src/_services/eczane.service.ts